import React from 'react';
import { Earth } from '../../../ui-library/typography';

const isAskOkeyFabric = (product) => product?.brandName === 'AskOkey';

const Blurb = ({ product }) => {
  if (!isAskOkeyFabric(product)) return null;

  return (
    <div className='mt-4'>
      <Earth>
        AskOkey is proud to present a unique old-world cloth, reborn: The iconic
        H. Lesser 17 Oz. With our partner, Harrisons of Edinburgh, we have
        recreated a classic weave, in a remarkable weight, a limited-edition
        dark navy herringbone pattern with a muted blue pinstripe. Powerful,
        vivacious, and as classic as it can get.
      </Earth>
      <br />
      <Earth>
        For more about our AskOkey Exclusive Cloth,{' '}
        <a href='https://blog.askokey.com/the-askokey-exclusive-cloth-is-here/'>
          visit our blog here
        </a>
        .
      </Earth>
    </div>
  );
};

export default Blurb;
